import { useTranslation } from 'react-i18next';

import { AuthLayout } from '@shared/layouts';
import PageContainer from '@shared/components/container/PageContainer';
import { ResetPasswordForm } from '@features/Auth/Reset-Password';

export const ResetPassword = () => {
  const { t } = useTranslation();

  return (
    <PageContainer title={t('formValidation.pageTitles.resetPassword')} useProductSuffix>
      <AuthLayout>
        <ResetPasswordForm />
      </AuthLayout>
    </PageContainer>
  );
};
